import { defineStore } from 'pinia'
import { services, getHeader, getUserInfo } from '@/assets/js/config.js'
import { useProductStore } from '@/stores/productStore'
import axios from 'axios'

export const useCommissionStore = defineStore('commissionStore', {
	state: () => ({
		hubManagerUserList: [],
		teamManagerUserList: [],
	}),
	getters: {

	},
	actions: {
		async generateCommission(commission_content) {
			if (_gHlp.isEmpty(commission_content)) {
				return false;
			}
			return await axios.post(services.commission + 'sale', commission_content, { headers: getHeader() })
				.then(res => {
					const sales = res.data;
					useProductStore().updateProduct(commission_content.prod_id, { prod_commission_at: sales.created_at });
					_gNotif.notifySuccess('<b>Commission</b> - Successfully Generated.')
				})
				.catch(e => {
					_gNotif.errorFunction(e)
				})

		},
		async getCommissionHubManagerUserList() {
			try {
				const res = await axios.get(services.commission + 'team-group/list/hub-manager', { headers: getHeader() })
				this.hubManagerUserList = res.data.data
			} catch (e) {
				this.hubManagerUserList = []
				console.log('Get user hub manager list failed:' + e.response.data.message)
			}
		},
		async getCommissionTeamManagerUserList() {
			try {
				const res = await axios.get(services.commission + 'team/list/team-manager', { headers: getHeader() })
				this.teamManagerUserList = res.data.data
			} catch (e) {
				this.teamManagerUserList = []
				console.log('Get user team manager list failed:' + e.response.data.message)
			}
		},
	}
})